module.exports = __webpack_public_path__ + "assets/img/btn-back-2fdcbdaf.png";